<template>
<v-dialog
    v-model="dialog"
    max-width="600"
    v-if="pte != null"
>
    <v-card>
        <v-card-title>{{title}}</v-card-title>

        <v-card-text>
            {{status_message}}

            <div
                style="margin-top: 15px; margin-bottom: 15px; text-align: center"
                v-if="pte.state == 'pending' || pte.state == 'running'"
            >
                <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                />
            </div>

        </v-card-text>

        <v-card-actions>
            <v-btn
                v-if="pte.state == 'failed' || pte.state == 'finished'"
                v-on:click="onClickTechnicalDetails"
                text
            >
                Technical Details
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
                v-if="pte.state == 'failed'"
                text
                @click="onClickFailed"
            >
                {{failed_button_text}}
            </v-btn>

            <v-btn
                v-if="pte.state == 'finished'"
                color="primary darken-1"
                text
                @click="onClickFinished"
            >
                {{finished_button_text}}
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            title: null,
            process_id: null,
            on_finished: () => {},
            on_failed: () => {},
            status: () => {},
            auto_proceed: false,

            status_message: null,
            pte: null,
            dialog: false,

            finished_button_text: 'Proceed',
            failed_button_text: 'Cancel',
        }
    },

    created () {
        this.$event_bus.$on('global-process-dialog', this.showDialog);
    },

    beforeDestroy () {
        this.$event_bus.$off('global-process-dialog',this.showDialog);
    },

    methods: {

        showDialog(params)
        {
            this.title = params.title ?? 'Progress';
            this.finished_button_text = params.finished_button_text ?? 'Proceed';
            this.failed_button_text = params.failed_button_text ?? 'Cancel';

            this.process_id = params.process_id;
            this.on_finished = params.on_finished ?? (() => {});
            this.on_failed = params.on_failed ?? (() => {});
            this.status = params.status ?? (() => { return null; });
            this.auto_proceed = params.auto_proceed ?? false;

            this.update();
        },

        update()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/process/:process_id',
            
                'params' : {
                        'process_id': this.process_id,
                    },
            
                'on_success': (pte) => {
                        this.pte = pte;
                        this.status_message = this.status(pte);
                        this.dialog = true;

                        if ( pte.state == 'finished' )
                        {
                            if ( this.auto_proceed )
                            {
                                this.dialog = false;
                                this.on_finished(this.pte);
                            }

                            return;
                        }

                        if ( pte.state == 'failed' )
                        {
                            if ( this.auto_proceed )
                            {
                                this.dialog = false;
                                this.on_failed(this.pte);
                            }

                            return;
                        }

                        window.setTimeout(this.update, 1000);
                    },
            
                'on_error': () => { window.setTimeout(this.update, 1000); },
            });
        },

        onClickFinished()
        {
            this.dialog = false;
            this.on_finished(this.pte);
        },

        onClickFailed()
        {
            this.dialog = false;
            this.on_failed(this.pte);
        },

        onClickTechnicalDetails()
        {
            this.$rc.technicalDetails({
                'title': 'Technical Details',
                'technical_details': this.pte.technical_details,
            });
        },

    },
}
</script>

<style lang="scss" scoped>
</style>